/**
 * 组件信息
 */
export const info = {
  name: 'xy-absolute-layout', // 组件名
  type: 'component-container', // 组件类型
  label: '自由布局', // 组件label
  icon: 'icon-xy-absolute-layout', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 400 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  /** 适配手机高度：为 true 且屏幕高度小于节点高度时，将 height 设为屏幕高度 */
  adaptPhoneHeight: { type: Boolean, default: false },
  element: {
    type: Object,
    default: () => ({
      // 组件名称
      name: '',
      // 组件类型
      type: '',
      // 组件id
      uuid: '',
      // 隐藏
      hiden: false,
      // 动画
      animations: [],
      // 组件样式
      style: {},
      // 组件数据
      data: {},
      // 多语言
      languages: [],
      // 数据源
      dataSource: null,
      // 事件
      events: []
    })
  },
  language: {
    type: String,
    default: 'en'
  },
  listIndex: {
    type: Object,
    default: null
  },
  listItemData: {
    type: [Object, Array, String, Number, Boolean],
    default: undefined
  }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [{}]
